import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';

import type {IUserAttributeSet} from '../types';

/**
 * `getAttributeFieldSet` request params
 * (what is used to send to server)
 */
export type GetAttributeFieldSetRequestOptions = {
	id: number;
};

/**
 * `getAttributeFieldSet` request
 * (what gets sent to the server)
 */
export type GetAttributeFieldSetRequest = [
	GetAttributeFieldSetRequestOptions['id'],
];

/**
 * `getAttributeFieldSet` response
 * (what comes back from the server)
 */
export type GetAttributeFieldSetResponse =
	SuccessResponse<GetAttributeFieldSetResult>;

/**
 * `getAttributeFieldSet` result
 * (what is utilized from the server response)
 */
export type GetAttributeFieldSetResult = IUserAttributeSet;

export const getAttributeFieldSetEndpoint = 'getAttributeFieldSet';

/**
 * Get attribute permission
 */
export const getAttributeFieldSet = async ({
	id,
}: GetAttributeFieldSetRequestOptions) => {
	const client = NetxQueryClient();

	const requestParams: GetAttributeFieldSetRequest = [id];

	return client
		.post<GetAttributeFieldSetResponse>(
			getAttributeFieldSetEndpoint,
			requestParams,
		)
		.then((response) => response.data.result);
};

export default getAttributeFieldSet;
